import React from 'react';
import { NavLink } from 'react-router-dom';
import DropdownButton from '@mynewsdesk/ui/lib/DropdownButton';
import MenuItem from '@mynewsdesk/ui/lib/MenuItem';
import Icon from '@mynewsdesk/ui/lib/Icon';

export const LoggedInProfileMenu = ({
  t,
  logout,
  userId,
  site,
  isJournalist,
  isPressOfficer,
  isAdmin,
}) => {
  const domain = window.location.hostname.replace(/^www\./, '');
  const sitePath = site.code === 'com' ? '' : site.path;
  const helpCenterSitePath = site.localized.helpCenter
    ? `/${site.defaultLocale}`
    : '/en';

  return (
    <DropdownButton
      title={t('navigation_profile-menu_title-profile')}
      id="dropdown-1"
      pullRight
      className="navigation_loggedin-profile-menu"
    >
      {(isPressOfficer || isAdmin) && (
        <>
          <MenuItem href={`https://publish.${domain}`}>
            {t('navigation_loggedin_dashboard')}
          </MenuItem>
          <MenuItem divider />
        </>
      )}
      <MenuItem href={`/profile/${userId}/settings`}>
        {t('navigation_loggedin_user-settings')}
      </MenuItem>
      {isJournalist && !isPressOfficer && !isAdmin && (
        <>
          <MenuItem href={`${sitePath}/journalist`}>
            {t('navigation_loggedin_get-mynewsdesk')}
          </MenuItem>
        </>
      )}
      <MenuItem href={`/profile/${userId}/edit`}>
        {t('navigation_loggedin_profile')}
      </MenuItem>
      <MenuItem href={`${sitePath}/library/`}>
        {t('global_footer-menu_library')}
      </MenuItem>
      <MenuItem href={`https://help.mynewsdesk.com${helpCenterSitePath}/`}>
        {t('global_footer-menu_help-support')}
      </MenuItem>
      <MenuItem divider />
      {isAdmin && (
        <>
          <MenuItem href={'/admin'}>Admin</MenuItem>
          <MenuItem divider />
        </>
      )}
      <MenuItem onClick={logout}>
        {t('navigation_log-out')} <Icon icon={['fas', 'sign-out-alt']} />
      </MenuItem>
    </DropdownButton>
  );
};

export const LoggedInHeaderMenu = ({ t, site, isJournalist, isAdmin }) => (
  <div className="mnd-navigation__header">
    <ul className="mnd-navigation-menu">
      <li className="mnd-navigation-menu__item">
        <NavLink
          to={{
            pathname: '/',
          }}
          isActive={(match, location) =>
            location.pathname === '/' ||
            location.pathname === '/stories' ||
            location.pathname === '/organisations'
          }
          activeClassName="mnd-navigation-menu__item-hitarea--active"
          className="mnd-navigation-menu__item-hitarea mnd-button--link"
        >
          {t('common_navigation-menu_title-stories')}
        </NavLink>
      </li>
      <li className="mnd-navigation-menu__item">
        <NavLink
          to={{
            pathname: '/alerts',
          }}
          isActive={(match, location) =>
            location.pathname === '/alerts' ||
            location.pathname === '/following'
          }
          activeClassName="mnd-navigation-menu__item-hitarea--active"
          className="mnd-navigation-menu__item-hitarea mnd-button--link"
        >
          {t('common_navigation-menu_title-subscriptions')}
        </NavLink>
      </li>
    </ul>
  </div>
);
